import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFeature: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFeature"><Path fillRule="evenodd" clipRule="evenodd" d="M12.75 1V9H11.25V1H12.75ZM6 4.93934L9.06066 8L8 9.06066L4.93934 6L6 4.93934ZM19.0607 6L16 9.06066L14.9393 8L18 4.93934L19.0607 6ZM1 11.25H9V12.75H1V11.25ZM15 11.25H23V12.75H15V11.25ZM9.06066 16L6 19.0607L4.93934 18L8 14.9393L9.06066 16ZM16 14.9393L19.0607 18L18 19.0607L14.9393 16L16 14.9393ZM12.75 15V23H11.25V15H12.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFeature;
